import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { TextField, Box, Button } from 'components/ui';
import { WideForm } from 'components/styles_components/form';
import validationSchema from 'validation/user/create';
import RoleSelect from 'components/form/role_select';

const Form = ({ onSubmit, onCancel, processing, initialValues }) => {
  const intl = useIntl();

  return (
    <Formik
      enableReinitialize
      validationSchema={validationSchema(intl)}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {(formik) => {
        return (
          <WideForm onSubmit={formik.handleSubmit}>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              id="email"
              name="email"
              label={intl.formatMessage({ id: 'user.email' }) + ' *'}
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={(formik.touched.email && Boolean(formik.errors.email)) || undefined}
              helperText={formik.touched.email && formik.errors.email}
            />
            <RoleSelect
              fullWidth
              margin="dense"
              id="role"
              name="role"
              label={intl.formatMessage({ id: 'user.role' }) + ' *'}
              value={formik.values.role}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={(formik.touched.role && Boolean(formik.errors.role)) || undefined}
              helperText={formik.touched.role && formik.errors.role}
            />
            <Button
              fullWidth
              disabled={!formik.isValid || processing || !formik.dirty}
              color="primary"
              variant="contained"
              type="submit"
            >
              <FormattedMessage id="button.invite" />
            </Button>
            <Box display="flex" justifyContent="flex-end">
              <Button variant="text" size="small" disabled={processing} onClick={onCancel}>
                <FormattedMessage id="button.cancel" />
              </Button>
            </Box>
          </WideForm>
        );
      }}
    </Formik>
  );
};

export default Form;
